import { playerSearchParams } from '../anniversary/format';

// Helpers for the Christmas Bonuses view. Amount formatting, statuses and the moderation editor are
// shared with the anniversary view (../anniversary).

// The "Christmas" filter: upcoming (next_christmas from today), all years, or one year.
export const UPCOMING = 'upcoming';
export const ALL_YEARS = 'all';

// christmasYearOptions lists next year down to the first year with Christmas proposals.
export const FIRST_CHRISTMAS_YEAR = 2025;
export const christmasYearOptions = (today = new Date()) => {
  const years = [];
  for (let y = today.getUTCFullYear() + 1; y >= FIRST_CHRISTMAS_YEAR; y -= 1) years.push(String(y));
  return years;
};

// christmasParams maps the filter state to API query params.
export const christmasParams = (f, todayISO) => {
  const p = { page: f.page, page_size: f.pageSize };
  if (f.christmas === UPCOMING) p.from = todayISO;
  else if (f.christmas !== ALL_YEARS) p.year = f.christmas;
  if (f.status !== 'all') p.status = f.status;
  if (f.bonusType !== 'all') p.bonus_type = f.bonusType;
  if (f.vipAgent !== 'all') p.vip_agent = f.vipAgent;
  Object.assign(p, playerSearchParams(f.player));
  if (f.sortCol) { p.sort_col = f.sortCol; p.sort_dir = f.sortDir; }
  return p;
};

// lockReasonText explains why a row cannot be moderated, from the API's lock_reason code.
export const christmasLockReasonText = (row) =>
  row.lock_reason === 'issued' ? 'Already issued' : 'Changes close 1 day before Christmas';

// christmasCountdown: "in 87 days" / "tomorrow" / "today" / "3 days ago" from days_until_christmas.
export const christmasCountdown = (days) => {
  if (days === null || days === undefined) return '';
  if (days === 0) return 'today';
  if (days === 1) return 'tomorrow';
  if (days === -1) return 'yesterday';
  return days > 0 ? `in ${days} days` : `${-days} days ago`;
};
